import { useState } from "react";
import { Link } from "react-router";
import { Button } from "@bookdental/ui";
import { ExecutarSolicitacao, type Solicitacao } from "./ExecutarSolicitacao";

const TIPO: Record<string, string> = { EXPORTACAO: "Exportação", RESET_DADOS: "Reset dos dados", EXCLUSAO: "Exclusão da conta" };
const STATUS: Record<string, string> = { PENDENTE: "Pendente", CONCLUIDA: "Atendida", RECUSADA: "Recusada", CANCELADA: "Cancelada" };

type Linha = Solicitacao & { criadaEm: string | Date; motivo: string | null; observacaoDoAdmin: string | null; concluidaEm: string | Date | null };

/** Pedidos LGPD com as ações do admin — usada na página Solicitações e na ficha do usuário. */
export function TabelaDeSolicitacoes({ itens, mostrarTitular = true }: { itens: Linha[]; mostrarTitular?: boolean }) {
  const [alvo, setAlvo] = useState<{ s: Solicitacao; modo: "executar" | "recusar" } | null>(null);
  if (itens.length === 0) return <p className="px-4 py-8 text-center text-sm text-admin-700">Nenhum pedido.</p>;
  return (
    <>
      <table className="w-full text-sm">
        <thead className="border-b border-admin-200 text-left text-xs uppercase tracking-wide text-admin-700">
          <tr>
            <th className="px-4 py-2.5">Pedido em</th>
            {mostrarTitular && <th className="px-4 py-2.5">Titular</th>}
            <th className="px-4 py-2.5">Tipo</th>
            <th className="px-4 py-2.5">Situação</th>
            <th className="px-4 py-2.5" />
          </tr>
        </thead>
        <tbody>
          {itens.map((s) => (
            <tr key={s.id} className="border-b border-zinc-100 align-top last:border-0">
              <td className="whitespace-nowrap px-4 py-2.5 text-admin-700">{new Date(s.criadaEm).toLocaleString("pt-BR")}</td>
              {mostrarTitular && (
                <td className="px-4 py-2.5">
                  {s.user ? <Link to={`/usuarios/${s.user.id}`} className="underline">{s.user.email}</Link> : <span className="text-admin-700">Conta excluída</span>}
                </td>
              )}
              <td className="px-4 py-2.5 font-medium text-admin-900">
                {TIPO[s.tipo]}
                {s.motivo ? <span className="block text-xs font-normal text-admin-700">“{s.motivo}”</span> : null}
              </td>
              <td className="px-4 py-2.5">
                {STATUS[s.status]}
                {s.observacaoDoAdmin ? <span className="block text-xs text-admin-700">{s.observacaoDoAdmin}</span> : null}
              </td>
              <td className="px-4 py-2.5 text-right">
                {s.status === "PENDENTE" && s.tipo !== "EXPORTACAO" && s.user && (
                  <div className="flex justify-end gap-1.5">
                    <Button size="sm" variant="outline" onClick={() => setAlvo({ s, modo: "recusar" })}>Recusar</Button>
                    <Button size="sm" className="bg-red-600 text-white hover:bg-red-700" onClick={() => setAlvo({ s, modo: "executar" })}>Executar</Button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ExecutarSolicitacao solicitacao={alvo?.s ?? null} modo={alvo?.modo ?? "executar"} onFechar={() => setAlvo(null)} />
    </>
  );
}
